module.exports = __webpack_public_path__ + "static/media/santa-teresa-bernini.2635e9d8.jpg";